<template>
  <div>
    <div class="homebox clearfix">
      <!-- 首页的头部 -->
      <Head />
      <!-- 首页的头部 -->
      <!-- 轮播banner -->
      <BannerList />
      <!-- 精品MOOC开放课 -->
      <Course :courseType="2" />
      <News :courseType="2" />
      <!-- 推荐教师 -->
      <!-- <TeacherList /> -->
    </div>
    <!-- 教师弹窗 -->
    <DialogTeacherDetail />
    <Footer />
  </div>
</template>

<script>
import Head from "./../components/Head";
import DialogTeacherDetail from "./../components/DialogTeacherDetail";
import Footer from "./../components/Footer";
import Course from "./components/Course";
import TeacherList from "./components/TeacherList";
import BannerList from "./components/BannerList";
import News from "./components/News";
export default {
  components: {
    Head,
    Course,
    TeacherList,
    BannerList,
    News,
    DialogTeacherDetail,
    Footer,
  },
  created() {
    console.log(version);
  },
};
</script>
<style scoped lang="scss">
// .main-wrapper {
// }
</style>